import { useEffect, useRef } from 'react';
import { BREADCRUMBS_ID, DEFAULT_BREADCRUMBS_HEIGHT } from '../constants';

export const useBreadcrumbHeight = () => {
  const breadcrumbsRef = useRef<HTMLDivElement>(null);
  const breadcrumbsHeight = breadcrumbsRef.current?.clientHeight ?? DEFAULT_BREADCRUMBS_HEIGHT;

  useEffect(() => {
    const breadcrumbs = document.getElementById(BREADCRUMBS_ID);
    // @ts-ignore
    breadcrumbsRef.current = breadcrumbs;
  }, []);

  return breadcrumbsHeight;
};
